(function () {
	let ticking = false,
		last_scroll_y = 0;

	function update_affix() {
		if (last_scroll_y > 0) {
			document.body.classList.add(`scrolled`);
			//	el.classList.add( `show` );
		} else {
			document.body.classList.remove(`scrolled`);
			// el.classList.remove( `show` );
		}

		ticking = false;
	}

	function request_tick() {
		if (ticking) {
			return;
		}

		requestAnimationFrame(update_affix);
		ticking = true;
	}

	function on_scroll() {
		last_scroll_y = window.pageYOffset;
		request_tick();
	}

	window.addEventListener(`scroll`, on_scroll);
	window.addEventListener(`resize`, on_scroll);

	on_scroll();
})();
